@import "../../variables.scss";

.timesheets_header {
  margin-bottom: 4rem;
}

.rotateimg180 {
  -webkit-transform: rotate(180deg);
  -moz-transform: rotate(180deg);
  -ms-transform: rotate(180deg);
  -o-transform: rotate(180deg);
  transform: rotate(180deg);
}
.profile {
  &__snackbar {
    border-radius: 4px;
    padding: 1rem;
    padding-bottom: 1.5rem;
    display: flex;
    @media (max-width: $size-sm) {
      flex-direction: column;
    }
    &_description {
      display: block;
      @media (max-width: $size-md) {
        font-size: 12px;
        line-height: 14px;
      }
      a {
        margin-left: 8px;
        @media (max-width: $size-md) {
          font-size: 12px;
          line-height: 14px;
        }
      }
    }
  }
}
